/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface FlightCheckoutTimelineEvent
 */
export interface FlightCheckoutTimelineEvent {
    /**
     *
     * @type {string}
     * @memberof FlightCheckoutTimelineEvent
     */
    eventType: string;
    /**
     *
     * @type {string}
     * @memberof FlightCheckoutTimelineEvent
     */
    status: string | null;
    /**
     *
     * @type {Date}
     * @memberof FlightCheckoutTimelineEvent
     */
    occurredAt: Date;
}

/**
 * Check if a given object implements the FlightCheckoutTimelineEvent interface.
 */
export function instanceOfFlightCheckoutTimelineEvent(value: object): value is FlightCheckoutTimelineEvent {
    if (!('eventType' in value) || value['eventType'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('occurredAt' in value) || value['occurredAt'] === undefined) return false;
    return true;
}

export function FlightCheckoutTimelineEventFromJSON(json: any): FlightCheckoutTimelineEvent {
    return FlightCheckoutTimelineEventFromJSONTyped(json, false);
}

export function FlightCheckoutTimelineEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightCheckoutTimelineEvent {
    if (json == null) {
        return json;
    }
    return {

        'eventType': json['event_type'],
        'status': json['status'],
        'occurredAt': (new Date(json['occurred_at'])),
    };
}

export function FlightCheckoutTimelineEventToJSON(json: any): FlightCheckoutTimelineEvent {
    return FlightCheckoutTimelineEventToJSONTyped(json, false);
}

export function FlightCheckoutTimelineEventToJSONTyped(value?: FlightCheckoutTimelineEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'event_type': value['eventType'],
        'status': value['status'],
        'occurred_at': value['occurredAt'].toISOString(),
    };
}
